class PointStorage {
  constructor() {
    this.LOCAL_STORAGE_USER = "point-info";
  }

  get pointsInfo() {
    return JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_USER));
  }
  set pointsInfo(data) {
    localStorage.setItem(this.LOCAL_STORAGE_USER, JSON.stringify(data));
  }

  clear() {
    localStorage.removeItem(this.LOCAL_STORAGE_USER)
  }
}

export default new PointStorage();